import { MenuItem, Select } from "@mui/material";
import { GridFilterOperator } from "@mui/x-data-grid-pro";
import createFilter from "./helpers/CreateFilterHelper";

const CustomFilterOperatorBreached = (props: any) => {
  const { item, applyValue } = props;
  const handleChange = (event: any) => {
    applyValue({ ...item, value: event.target.value });
  };
  return (
    <Select
        sx={{maxWidth: '210px', width: '100%', justifyContent: 'center'}}
        labelId="breached-select-label"
        id="breached-select"
        value={item.value || ''}
        onChange={handleChange}
        fullWidth
    >
        <MenuItem value={'true'}>Breached</MenuItem>
        <MenuItem value={'false'}>Not Breached</MenuItem>
    </Select>
  );
};

const BreachedFilterOperator: GridFilterOperator[] = [
  {
      label: 'Is',
      value: 'eq',
      getApplyFilterFn: createFilter((cellValue, filterValue) => {
          if (cellValue === undefined || filterValue === undefined) return false;
          
          const normalizedCellValue = cellValue.toString().toLowerCase();
          const normalizedFilterValue = filterValue.toString().toLowerCase();
          
          return normalizedCellValue === normalizedFilterValue;
      }),
      InputComponentProps: { type: 'text' },
      InputComponent: CustomFilterOperatorBreached,
  }
];
  
export default BreachedFilterOperator;